<div class="details-tab" *ngIf="audience as a">
  <div class="details-section">
    <div class="details-section__title">{{ 'audiences.additionalInfo.details.info' | translate }}</div>
    <div class="details-grid">
      <div class="details-row">
        <span class="details-label">{{ 'audiences.additionalInfo.details.status' | translate }}</span>
        <span class="details-value"><span class="status-chip" [attr.data-status]="a.status">{{ a.status }}</span></span>
      </div>
      <div class="details-row">
        <span class="details-label">{{ 'audiences.additionalInfo.details.schedule' | translate }}</span>
        <span class="details-value">{{ a.schedule || '—' }}</span>
      </div>
      <div class="details-row">
        <span class="details-label">{{ 'audiences.additionalInfo.details.volume' | translate }}</span>
        <span class="details-value">{{ a.volume || '—' }}</span>
      </div>
      <div class="details-row" *ngIf="ownerLabel">
        <span class="details-label">{{ 'audiences.additionalInfo.details.owner' | translate }}</span>
        <span class="details-value">{{ ownerLabel }}</span>
      </div>
      <div class="details-row" *ngIf="a.description">
        <span class="details-label">{{ 'audiences.additionalInfo.details.description' | translate }}</span>
        <span class="details-value">{{ a.description }}</span>
      </div>
      <div class="details-row" *ngIf="a.audienceQualityIndex != null">
        <span class="details-label">{{ 'audiences.additionalInfo.details.quality' | translate }}</span>
        <span class="details-value">{{ a.audienceQualityIndex }}</span>
      </div>
      <div class="details-row" *ngIf="a.globalTimerange != null">
        <span class="details-label">{{ 'audiences.additionalInfo.details.timerange' | translate }}</span>
        <span class="details-value">{{ a.globalTimerange }}d</span>
      </div>
      <div class="details-row">
        <span class="details-label">{{ 'audiences.additionalInfo.details.expand' | translate }}</span>
        <span class="details-value">{{ (a.expandSimilarUsers ? 'common.yes' : 'common.no') | translate }}</span>
      </div>
    </div>
  </div>

  <div class="details-section">
    <div class="details-section__title">{{ 'audiences.additionalInfo.details.dates' | translate }}</div>
    <div class="details-grid">
      <div class="details-row" *ngIf="a.createdAt">
        <span class="details-label">{{ 'audiences.additionalInfo.details.created' | translate }}</span>
        <span class="details-value">{{ a.createdAt }}</span>
      </div>
      <div class="details-row">
        <span class="details-label">{{ 'audiences.additionalInfo.details.lastExtraction' | translate }}</span>
        <span class="details-value">{{ a.lastExtraction || '—' }}</span>
      </div>
      <div class="details-row">
        <span class="details-label">{{ 'audiences.additionalInfo.details.nextExtraction' | translate }}</span>
        <span class="details-value">{{ a.nextExtraction || '—' }}</span>
      </div>
      <div class="details-row" *ngIf="a.endDate">
        <span class="details-label">{{ 'audiences.additionalInfo.details.endDate' | translate }}</span>
        <span class="details-value">{{ a.endDate }}</span>
      </div>
    </div>
  </div>

  <div class="details-section">
    <div class="details-section__title">{{ 'audiences.additionalInfo.details.id' | translate }}</div>
    <div class="details-row">
      <span class="details-value details-value--id" (click)="copyId()" [class.is-copied]="copied"
            [title]="(copied ? 'audiences.additionalInfo.details.copied' : 'audiences.additionalInfo.details.copyId') | translate">
        {{ a.id }} <span class="copy-hint">⧉</span>
      </span>
    </div>
  </div>

  <div class="details-section">
    <div class="details-section__title">{{ 'audiences.additionalInfo.details.costs.title' | translate }}</div>
    <button type="button" class="load-costs-btn" *ngIf="!costInsights" (click)="loadCostInsights()" [disabled]="costInsightsLoading">
      {{ (costInsightsLoading ? 'audiences.additionalInfo.details.costs.loading' : 'audiences.additionalInfo.details.costs.load') | translate }}
    </button>
    <p class="costs-error" *ngIf="!costInsightsLoading && costInsightsError">{{ 'audiences.additionalInfo.details.costs.error' | translate }}</p>
    <div class="details-grid" *ngIf="costInsights">
      <div class="details-row" *ngIf="costInsights.LastExtractionCost != null">
        <span class="details-label">{{ 'audiences.additionalInfo.details.costs.lastExtraction' | translate }}</span>
        <span class="details-value">{{ costInsights.LastExtractionCost | number:'1.2-2' }} €</span>
      </div>
      <div class="details-row">
        <span class="details-label">{{ 'audiences.additionalInfo.details.costs.avgExecution' | translate }}</span>
        <span class="details-value">{{ costInsights.AvarageExecutionCost | number:'1.2-2' }} €</span>
      </div>
      <div class="details-row">
        <span class="details-label">{{ 'audiences.additionalInfo.details.costs.totalCost' | translate }}</span>
        <span class="details-value">{{ costInsights.TotalCost | number:'1.2-2' }} €</span>
      </div>
    </div>
  </div>

  <div class="details-section" *ngIf="filterTypes.length">
    <div class="details-section__title">{{ 'audiences.additionalInfo.details.filters' | translate }}</div>
    <div class="chips">
      <span class="chip" *ngFor="let t of filterTypes">{{ t }}</span>
    </div>
  </div>

  <div class="details-section" *ngIf="tags.length">
    <div class="details-section__title">{{ 'audiences.additionalInfo.details.tags' | translate }}</div>
    <div class="chips">
      <span class="chip chip--tag" *ngFor="let tag of tags">{{ tag }}</span>
    </div>
  </div>
</div>
